import _ from "lodash";
import React, { useState } from "react";
import { useEffect } from "react";
import { TableControl } from "../../../../components/controls";
import { useAppUserManager } from "../../../../hooks/useManagers";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/StickyNote2";
import ButtonControl from "../../../../components/controls/ButtonControl";
import SystemTypes from "../../../../SystemTypes";
import { FormatSchoolYearIdentifier } from "../../../../utilities/SchoolYearFormatter";

const DataDashboardSurveyList = ({
  filteredItems,
  orgs,
  districts,
  schools,
  onEdit,
  onPrint,
  onView,
  onDelete,
  appUserMgr,
  handlePrintEmpty,
  printing,
  allowEdit,
}) => {
  const [rows, setRows] = useState([]);
  const [columns] = useState([
    {
      header: "Title",
      dataProp: "GeneralSurveyName",
      width: "20%",
      canSort: true,
    },
    {
      header: "Data Collection Period",
      dataProp: "DataCollectionPeriod",
      width: "10%",
      canSort: true,
    },
    {
      header: "School Year",
      dataProp: "SchoolYear",
      width: "10%",
      canSort: true,
    },
    {
      header: "Organization, District, School",
      dataProp: "FullOrg",
      width: "18%",
      canSort: true,
      sortBy: "FullOrg",
    },
    {
      header: "Teacher Name",
      dataProp: "TeacherName",
      width: "16%",
      canSort: true,
    },
    {
      header: "Date",
      dataProp: "StartDate",
      datatype: "dateTime",
      width: "14%",
      canSort: true,
    },
    {
      header: "Survey By",
      dataProp: "AssignedTo",
      width: "16%",
      canSort: true,
    },
    {
      header: "Status",
      dataProp: "DisplayStatus",
      sortBy: "status",
      width: "8%",
      canSort: true,
    },
  ]);
  const statusIdentifer = (item) => {
    if (item?.Survey?.SurveyStatusType == 1) {
      return "In Progress";
    } else if (item?.Survey?.SurveyStatusType == 2) {
      return "In Progress";
    } else if (item?.Survey?.SurveyStatusType == 3) {
      return "Submitted";
    } else return "Not Started";
  };

  const userPositionIdentifer = (value) => {
    const differentName = _.find(
      appUserMgr?.AppUserState.observationConfig.UserPositionAlternativeMap,
      (x) => x?.UserPosition == value && x?.Name
    )?.Name;
    if (differentName) {
      return differentName;
    }
    if (value === 40) {
      return "Master Teacher";
    } else if (value === 41) {
      return "Mentor Teacher";
    } else return "Teacher";
  };

  useEffect(() => {
    let newRows = [];
    if (filteredItems && orgs && districts && schools) {
      _.each(filteredItems, (st) => {
        let surveyedEmail = st?.Survey?.User?.UserName ?? st?.UserSurveyMap?.User.UserName;
        let org = orgs.find(
          (x) => x.OrgId === st.Survey?.ClientId ||x.OrgId === st.Survey?.User?.OrganizationIds?.first() || x.OrgId === st?.UserSurveyMap?.User.OrganizationIds?.first()
        );
        let district = districts.find(
          (x) => x.Id === st.Survey?.DistrictId || x.Id === st.Survey?.User?.DistrictIds?.first() || x.Id === st?.UserSurveyMap?.User.DistrictIds?.first()
        );
        let school = schools.find(
          (x) => x.Id === st.Survey?.SchoolId || x.Id === st.Survey?.User?.SchoolIds?.first() || x.Id === st?.UserSurveyMap?.User.SchoolIds?.first()
        );

        let teacherName = st?.Sections?.find(x => x.SurveyTemplateFieldId === 'b4c96ba1-2f68-4c96-9f78-0daa11000163')?.Value;
        let dataCollectionPeriod = st?.Sections?.find(x => x.SurveyTemplateFieldId === '704c4f21-83c4-49a3-a452-63de68e0cfeb')?.Value;
        let schoolYear = FormatSchoolYearIdentifier(st?.Survey?.SchoolYearIdentifier);

        newRows.push({
          ...st,
          AssignedTo: (
            <div>
              {st.AssignedTo}
              <br />
              <span className="table-sub-email-survey">{surveyedEmail}</span>
            </div>
          ),
          FullOrg: (
            <>
              {`${org?.Name ?? ""}`}
              <br />
              {`${district?.Name ?? ""}`}
              <br /> {`${school?.Name ?? ""}`}
            </>
          ),
          AssignedBy: (
            <div>
              {st?.AssignedByUser?.FullName}
              <br />
              <span className="table-sub-email-survey">
                {st?.AssignedByUser?.UserName}
              </span>
            </div>
          ),
          AssignedByRole: userPositionIdentifer(st?.User?.UserPositionType),
          status: statusIdentifer(st),
          DisplayStatus: (
            <>
              {statusIdentifer(st)}
              {st.GeneralSurvey?.IsActive === false ||
              st.GeneralSurvey?.IsDeleted === true ? (
                <>
                  <br />
                  (Inactive)
                </>
              ) : null}
            </>
          ),
          TeacherName: teacherName,
          DataCollectionPeriod: dataCollectionPeriod,
          SchoolYear: schoolYear,
        });
      });
      setRows(newRows);
    }
  }, [filteredItems, orgs, districts, schools]);

  const handleCheckDisableAction = (row, action) => {
    if (action.toLowerCase() == "edit") {
      return (
        row.GeneralSurvey.IsActive === false ||
        row.GeneralSurvey.IsDeleted === true ||
        statusIdentifer(row) === "Submitted" ||
        (row.UserSurveyMap.UserId !==
          appUserMgr?.AppUserState?.userProfile?.Id &&
          appUserMgr?.AppUserState?.userProfile?.UserPositionType !== 1)
      );
    } else if (action.toLowerCase() == "view") {
      return (
        statusIdentifer(row) === "In Progress" ||
        statusIdentifer(row) === "Not Started"
      );
    } else if (action.toLowerCase() == "print") {
      return (
        statusIdentifer(row) === "Not Started" ||
        statusIdentifer(row) === "In Progress" ||
        printing
      );
    } else {
      return false;
    }
  };

  const checkLoadingAction = (action, id) => {
    if (action === "print" && printing) {
      return action;
    } else return id;
  };

  const handleCheckHideDelete = (row, action) => {
    if (action === "delete") {
      if (!allowEdit) return true;
      if (statusIdentifer(row) === "Not Started") {
        return true;
      } else {
        return !(
          appUserMgr.AppUserState.userProfile.UserPositionType ===
            SystemTypes.UserPositionType.Admin ||
          appUserMgr.AppUserState.userProfile.UserPositionType === 20
        );
      }
    }
    return false;
  };

  return (
    <>
      <div className="contentDisplay-list">
        <TableControl
          columns={columns}
          data={rows}
          checkDisableAction={handleCheckDisableAction}
          checkLoadingAction={checkLoadingAction}
          useIntegratedPaging={["10", "25", "50", "100"]}
          onPrint={async (row) => await onPrint(row)}
          printing={printing}
          onCustom1={{
            action: (row) => (
              <div title="Print Blank Survey" className="icon-wrapper">
                <LocalPrintshopOutlinedIcon
                  className="icon"
                  onClick={() => {
                    if (!handleCheckDisableAction(row, "custom1")) {
                      handlePrintEmpty(row, true);
                    }
                  }}
                />
              </div>
            ),
          }}
          onEdit={(row) => onEdit(row)}
          onView={(row) => onView(row)}
          onDelete={(row) => onDelete(row)}
          checkHideAction={handleCheckHideDelete}
        />
      </div>
    </>
  );
};

export default DataDashboardSurveyList;

